import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

const label = (step: string) => step.replace(/_/g, " ");

// ----------------------- STEPS DONE BEFORE THE FAILURE ------------------------------------
export default function StepTrail({ steps, failedAt }: { steps?: string[]; failedAt: string }) {
  if (!steps?.length) return null;
  return (
    <ol className="glass flex flex-wrap items-center gap-1.5 p-3" aria-label="Steps">
      {steps.map((step, index) => (
        <li key={`${step}-${index}`} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-500/10 px-2.5 py-1 font-[Gilroy-Medium] text-[12px] text-emerald-700 dark:text-emerald-300">
          <FontAwesomeIcon icon={faCheck} className="text-[10px]" />
          {label(step)}
        </li>
      ))}
      <li className="inline-flex items-center gap-1.5 rounded-full bg-rose-500/10 px-2.5 py-1 font-[Gilroy-Bold] text-[12px] text-rose-600 dark:text-rose-300">
        <FontAwesomeIcon icon={faXmark} className="text-[10px]" />
        failed: {label(failedAt)}
      </li>
    </ol>
  );
}
